import React from 'react';

import AskCommiteeDecisionView from 'components/CommiteeDecision/AskCommiteeDecisionView';

const AskCommiteeDecision = () => {
  return <AskCommiteeDecisionView />;
};

export default AskCommiteeDecision;
